import React from 'react';
import Child1 from '../../../../../images/bookingDetailAvatars/kid_1.svg';
import Child2 from '../../../../../images/bookingDetailAvatars/kid_2.svg';
import Child3 from '../../../../../images/bookingDetailAvatars/kid_3.svg';
import Child4 from '../../../../../images/bookingDetailAvatars/kid_4.svg';
// import Child1 from '../../../../../images/bookingDetailAvatars/kid_5.svg';
// import Child2 from '../../../../../images/bookingDetailAvatars/kid_6.svg';

const ChildAvatar = () => {
    const avatars = [Child1, Child2, Child3, Child4];
    const randomIndex = Math.floor(Math.random() * avatars.length);
    const selectedAvatar = avatars[randomIndex];

    return (
        <img
            src={selectedAvatar}
            className='booking-guest__avatar'
            alt='avatar child guest'
        />
    );
};

export default ChildAvatar;
